<script>
import { Pie } from 'vue-chartjs'
export default {
  extends: Pie,
  props: {
    chartData: {
      type: Object,
      default: {}
    },
  },
  methods:{
    onload(info)
    {
      this.renderChart(
        {
          labels: info.labels,
          datasets: info.datasets
        },

        {responsive: true, maintainAspectRatio: true})
    }
  },
  created() {

  },
  mounted () {
    this.onload(this.chartData)
  },
}
</script>
